import { useForm } from 'react-hook-form';
import { PrimaryButton, SecondaryButton } from '@weareopenr/component-library';
import { OptionGroupPriceSchemes } from 'src/components/CreateOptionGroupModal/OptionGroupPriceSchemes/OptionGroupPriceSchemes';
import { IOptionGroupValues } from 'src/components/CreateOptionGroupModal/types';
import { ButtonContainer } from '../../ButtonContainer/ButtonContainer';
import { IGlobalItem } from '../types';

interface IGlobalItemPriceSchemesProps {
  wizardItem: Partial<IGlobalItem>;
  onBackOrClose: () => void;
  onContinue: () => void;
  setGlobalItem: (data: Partial<IGlobalItem>) => void;
}

export const GlobalItemPriceSchemes = ({
  wizardItem,
  onBackOrClose,
  onContinue,
  setGlobalItem,
}: IGlobalItemPriceSchemesProps) => {
  const formFields = useForm<IOptionGroupValues>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    defaultValues: {
      name: wizardItem.modifier_groups?.[0]?.name || '',
      price_scheme_ids: wizardItem.price_scheme_ids,
    },
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = formFields;

  const onFormSubmit = (data: IOptionGroupValues) => {
    setGlobalItem({ price_scheme_ids: data.price_scheme_ids });
    onContinue();
  };

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <OptionGroupPriceSchemes useFormReturn={formFields} />

      <ButtonContainer
        left={
          <SecondaryButton type="button" size="full-width" buttonStyle="outline" onClick={onBackOrClose}>
            Back
          </SecondaryButton>
        }
        right={
          <PrimaryButton size="full-width" type="submit" loading={isSubmitting}>
            Continue
          </PrimaryButton>
        }
      />
    </form>
  );
};
